export default __webpack_public_path__ + "static/media/turismo.c3b36559.jpg";